var map = {
	"./THB/BAY.png": "6ee1",
	"./THB/BBL.png": "39bc",
	"./THB/KBANK.png": "bf70",
	"./THB/KTB.png": "b6a0",
	"./THB/SCB.png": "b83d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ecb0";